module.exports = __webpack_public_path__ + "img/_011.118d123a.png";